import { Component } from 'react';
import axios from "axios"
import get from 'lodash/get'
import Constants from "../Constants";


const incrementSignal = () => {
    const signalCount = Number(localStorage.getItem('signal'))
    localStorage.setItem("signal", signalCount + 1)
}

const decrementSignal = () => {
    const signalCount = Number(localStorage.getItem('signal'))
    localStorage.setItem("signal", signalCount - 1)
}


const getHeaders = (headers,scId) => {
    if(scId){
        return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            Scid: scId
        },
        };
    }else{
        return {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                ScId: localStorage.getItem("ScId")
            },
        };
    }
};

const handleAuth = (error) => {
    const status = get(error, 'response.status')
     if(status === 401){
         window.location = Constants.AUTH_URL;
     }
};

class ApiCaller extends Component {
    

    callGetApi(url, headerMap, successCallBack, failedCallBack) {
        // axios.get(url, {
        //     headers: this.getHeaders(headerMap),
        incrementSignal()
        axios.get(url, getHeaders()).then((result) => {
            if (successCallBack != null) {
                successCallBack(result.data);
            }
        }).catch((error) => {
            handleAuth(error)
            if (failedCallBack != null) {
                failedCallBack(error);
            }
        }).finally(decrementSignal)
    }

    callPostApi(url, data, headerMap, successCallBack, failedCallBack,scId) {
        // axios.post(url, data, {
        //     headers: this.getHeaders(headerMap),
        // })
        incrementSignal()
        axios.post(url, data, getHeaders(headerMap,scId)).then((result) => {
            if (successCallBack != null) {
                successCallBack(result.data);
            }
        }).catch((error) => {
            handleAuth(error)
            if (failedCallBack != null) {
                failedCallBack(error);
            }
        }).finally(decrementSignal)
    }

    callPostApiWithoutAuth(url, data, successCallBack, failedCallBack) {
        incrementSignal()
        axios.post(url, data, {}).then((result) => {
            successCallBack(result.data);
        }).catch((error) => {
            handleAuth(error)
            if (failedCallBack != null) {
                failedCallBack(error);
            }
        }).finally(decrementSignal)
    }   

    callPutApi(url, data, headerMap, successCallBack, failedCallBack) {
        incrementSignal(); // Start the signal (e.g., show loader)
    
        axios.put(url, data, getHeaders())
        .then((result) => {
            if (result.status >= 200 && result.status < 300) {
                successCallBack?.(result.data);
            } else {
                console.warn("Non-2xx Response:", result);
                failedCallBack?.({
                    message: "Unexpected response from the server.",
                    response: result,
                });
            }
        })
        .catch((error) => {
            console.error("API Error:", error);
            handleAuth?.(error);
            failedCallBack?.(error);
        })
        .finally(() => {
            decrementSignal();
        });
    
    }
    
    callDeleteApi(url, headerMap, successCallBack, failedCallBack) {
        // axios.delete(url, {
        //     headers: this.getHeaders(headerMap),
        // })
        incrementSignal()
        axios.delete(url, getHeaders()).then((result) => {
            if (successCallBack != null) {
                successCallBack(result.data);
            }
        }).catch((error) => {
            handleAuth(error)
            if (failedCallBack != null) {
                failedCallBack(error);
            }
        }).finally(decrementSignal)
    }
}

export default new ApiCaller();
